<template>
  <span class="eb-font-type">
      <slot></slot>
  </span>
</template>
<script>
export default {
  name: 'ebFontType'
};
</script>
<style scoped lang="less">
</style>
